const minWidthDevice = 360
const isDeviceSupported = () => {
    return screen.width >= minWidthDevice
}

export default isDeviceSupported
